import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@mui/material";
import { useState } from "react";
import { useFormContext } from "react-hook-form";
import illustration from "../../../../assets/illustrations/illustration_rectangle_frame.svg";
import { IDispenseRecordSchema } from "../../../../@types/dispense";

const records = [
  { type: "Eye Checking", date: new Date(2024, 2, 19) },
  { type: "Nhs-Eyetest", date: new Date(2024, 2, 20) },
];

const FinalSummary = ({ finalData }: any) => {
  const { getValues } = useFormContext();
  const [openModal, setOpenModal] = useState(false);
  const [previousRecords, setPreviousRecords] =
    useState<IDispenseRecordSchema[]>(records);

  const rightFinalSPH = getValues("final.distanceRightSPH");
  const rightFinalCYL = getValues("final.distanceRightCYL");
  const rightFinalAxis = getValues("final.distanceRightAxis");
  const nearRightAddFinal = getValues("final.nearRightAdd");
  const intermediateRightFinal = getValues("final.intermediateRightAdd");
  const distanceRightPrismFinal = getValues("final.distanceRightPrism");

  const leftFinalSPH = getValues("final.distanceLeftSPH");
  const leftFinalCYL = getValues("final.distanceLeftCYL");
  const leftFinalAxis = getValues("final.distanceLeftAxis");
  const nearLeftAddFinal = getValues("final.nearLeftAdd");
  const intermediateLeftFinal = getValues("final.intermediateLeftAdd");
  const distanceLeftPrismFinal = getValues("final.distanceLeftPrism");

  const isRightEmpty =
    !rightFinalSPH &&
    !rightFinalCYL &&
    !rightFinalAxis &&
    !nearRightAddFinal &&
    !intermediateRightFinal &&
    !distanceRightPrismFinal &&
    !finalData?.distanceRightSPH &&
    !finalData?.distanceRightCYL &&
    !finalData?.distanceRightAxis &&
    !finalData?.nearRightAdd &&
    !finalData?.intermediateRightAdd &&
    !finalData?.distanceRightPrism;

  const isLeftEmpty =
    !leftFinalSPH &&
    !leftFinalCYL &&
    !leftFinalAxis &&
    !nearLeftAddFinal &&
    !intermediateLeftFinal &&
    !distanceLeftPrismFinal &&
    !finalData?.distanceLeftSPH &&
    !finalData?.distanceLeftCYL &&
    !finalData?.distanceLeftAxis &&
    !finalData?.nearLeftAdd &&
    !finalData?.intermediateLeftAdd &&
    !finalData?.distanceLeftPrism;

  const handleOpenModalDispense = () => setOpenModal(!openModal);

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "end", width: "100%", mb: 2 }}>
        <Typography variant="h6" sx={{ mr: 1 }}>
          Final
        </Typography>

        {/* <Box sx={{ flexGrow: 1, borderBottom: "1px solid #ccc", mb: 0 }} />

        <Button
          variant="outlined"
          onClick={handleOpenModalDispense}
          sx={{
            ml: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            lineHeight: 1,
            fontWeight: "100",
          }}>
          Previous <span>Records</span>
        </Button> */}
      </Box>

      <Dialog
        fullWidth
        maxWidth="lg"
        open={openModal}
        onClose={handleOpenModalDispense}>
        <DialogContent sx={{ px: 0 }}>
          <Table>
            <TableBody>
              <TableRow
                sx={{
                  borderBottom: "1px solid rgba(0, 0, 0, 0.2)",
                  backgroundColor: "#919EAB14",
                }}>
                <TableCell
                  sx={{
                    fontWeight: "600",
                    fontSize: "18px",
                    textAlign: "center",
                  }}>
                  Examination Date
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "600",
                    fontSize: "18px",
                    textAlign: "center",
                  }}>
                  Examination Type
                </TableCell>
              </TableRow>
              {previousRecords.map((item, index) => (
                <TableRow
                  key={index}
                  sx={{ borderBottom: "1px solid rgba(0, 0, 0, 0.2)" }}>
                  <TableCell
                    sx={{
                      fontWeight: "600",
                      fontSize: "18px",
                      textAlign: "center",
                    }}>
                    {item.date.toLocaleDateString()}
                  </TableCell>
                  <TableCell
                    sx={{
                      fontSize: "18px",
                      textAlign: "center",
                    }}>
                    {item.type}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </DialogContent>
      </Dialog>

      <Box
        sx={{
          mb: 3,
          padding: 2,
          borderRadius: "15px",
          border: "1px solid #6373813b",
          position: "relative",
        }}>
        <Typography sx={{ mb: 5, ml: 3 }}>
          Right:
          {isRightEmpty ? (
            <Typography sx={{ display: "inline", ml: 3 }}>
              No records found
            </Typography>
          ) : (
            <Typography sx={{ display: "inline", ml: 3 }}>
              {rightFinalSPH || finalData?.distanceRightSPH}/
              {rightFinalCYL || finalData?.distanceRightCYL} ×{" "}
              {rightFinalAxis || finalData?.distanceRightAxis}
              {nearRightAddFinal
                ? ` ADD + ${nearRightAddFinal}`
                : finalData?.nearRightAdd
                ? ` ADD + ${finalData.nearRightAdd}`
                : ""}
              {intermediateRightFinal || finalData?.intermediateRightAdd
                ? `, Inter ADD + ${
                    intermediateRightFinal || finalData?.intermediateRightAdd
                  }`
                : ""}
              {distanceRightPrismFinal || finalData?.distanceRightPrism
                ? ` ${distanceRightPrismFinal || finalData?.distanceRightPrism}`
                : ""}
            </Typography>
          )}
        </Typography>

        <Typography sx={{ ml: 3 }}>
          Left:
          {isLeftEmpty ? (
            <Typography sx={{ display: "inline", ml: 3 }}>
              No records found
            </Typography>
          ) : (
            <Typography sx={{ display: "inline", ml: 3 }}>
              {leftFinalSPH || finalData?.distanceLeftSPH}/
              {leftFinalCYL || finalData?.distanceLeftCYL} ×{" "}
              {leftFinalAxis || finalData?.distanceLeftAxis}
              {nearLeftAddFinal
                ? ` ADD + ${nearLeftAddFinal}`
                : finalData?.nearLeftAdd
                ? ` ADD + ${finalData.nearLeftAdd}`
                : ""}
              {intermediateLeftFinal || finalData?.intermediateLeftAdd
                ? `, Inter ADD + ${
                    intermediateLeftFinal || finalData?.intermediateLeftAdd
                  }`
                : ""}
              {distanceLeftPrismFinal || finalData?.distanceLeftPrism
                ? ` ${distanceLeftPrismFinal || finalData?.distanceLeftPrism}`
                : ""}
            </Typography>
          )}
        </Typography>
      </Box>
    </Box>
  );
};

export default FinalSummary;
